import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

const NoData = () => {
  return (
    <div className='no-data'>
      <FontAwesomeIcon icon={faTriangleExclamation} size='2x' color='#ffc107' />
      <p>Nu exista tranzactii care sa corespunda criteriilor de filtrare</p>
    </div>
  );
};

export default NoData;
